export default __webpack_public_path__ + "static/media/light_up.8f58281d.png";